export default __webpack_public_path__ + "static/media/Beard_5_C4.bfcb50e7.svg";